import memoizeOne from 'memoize-one';
import React from 'react';
import { connect } from 'react-redux';

import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import PrivateCourseListContainer from '@src/components/course/list/catalog/PrivateCourseListContainer';
import { IUserInfo } from '@src/model/user/User';
import { ICourseListFilter } from '@src/service/business/courses/courseListBusinessStore';
import LoginBusinessStore from '@src/service/business/login/loginBusinessStore';

// -- Prop types
// ----------

export interface ICreatorCourseListContainerOwnProps { }
export interface ICreatorCourseListContainerStateProps {
  currentUser: IUserInfo;
}
export interface ICreatorCourseListContainerDispatchProps { }
type ICreatorCourseListContainerProps = ICreatorCourseListContainerOwnProps & ICreatorCourseListContainerStateProps & ICreatorCourseListContainerDispatchProps & IWithLocalizeOwnProps;

// -- Component
// ----------

/** Container component for list of all courses. */
class CreatorCourseListContainer extends React.Component<ICreatorCourseListContainerProps> {
  private createPredefinedListFilter = memoizeOne(
    (creatorUser: IUserInfo): ICourseListFilter => {
      return { createdBy: creatorUser.id };
    }
  );

  render = () => {
    const predefinedListFilter = this.createPredefinedListFilter(this.props.currentUser);
    return <PrivateCourseListContainer predefinedListFilter={predefinedListFilter} />;
  };
}

// -- HOCs and exports
// ----------

// `state` parameter needs a type annotation to type-check the correct shape of a state object but also it'll be used by "type inference" to infer the type of returned props
const mapStateToProps = (state: any): ICreatorCourseListContainerStateProps => ({
  currentUser: LoginBusinessStore.selectors.getCurrentUser(state),
});

// `dispatch` parameter needs a type annotation to type-check the correct shape of an action object when using dispatch function
const mapDispatchToProps = (dispatch: any): ICreatorCourseListContainerDispatchProps => ({});

export default connect<ICreatorCourseListContainerStateProps, ICreatorCourseListContainerDispatchProps, ICreatorCourseListContainerOwnProps>(mapStateToProps, mapDispatchToProps)(withLocalize(CreatorCourseListContainer as any));
